import { Component, OnInit } from '@angular/core';
import { ParEmployeeService } from '../../services/par_employees/par_employees.service';

@Component({
  selector: 'app-paremployee-summary-for-par',
  templateUrl: './paremployee-summary-for-par.component.html',
  styleUrls: ['./paremployee-summary-for-par.component.css']
})
export class ParemployeeSummaryForParComponent implements OnInit {
  getAllPARSummaryData: any = {
    Name: '',
    Type: '',
    DateIncorporated: '',
    StateIncorporated: '',
    Address: '',
    Phone: '',
    Description: '',
    DunnAndBradStreet: '',
    TaxId: '',
    Website: '',
    PublicOrPrivate: '',
    ComplianceContract: '',
    NumberOfEmployees: ''
  };
  todayDate: any;
  constructor(private parEmployeeService: ParEmployeeService) { }

  ngOnInit() {
  this.parEmployeeService.getParSummary().subscribe(res => {
    this.getAllPARSummaryData = res.Summary[0];
    });
  }

  convertToDate(expirationDate) {
    const currentDate = new Date();
    this.todayDate = currentDate.getMonth() + 1 + '/' + currentDate.getDate() + '/' + currentDate.getFullYear();
    if (expirationDate !== null && expirationDate !== '' && expirationDate !== 'Invalid Date' && expirationDate !== undefined) {
      const expiration = new Date(expirationDate);
      if (expiration !== undefined) {
        const expDate = expiration.getMonth() + 1 + '/' + expiration.getDate() + '/' + expiration.getFullYear();
        return expDate;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/paremployee-summary-for-par/paremployee-summary-for-par.component.ts